import { AppState, HomePage90minAppState } from '../../initialStateRegistration';
import { HomePage90minState } from './homePage90min.initialState';

export const getHomePage = (state: AppState) => (state as HomePage90minAppState).template;

export const getSectionDataByKey = (key: keyof HomePage90minState) => (state: AppState) => getHomePage(state)[key];

export const getSectionArticlesByKey = (key: keyof HomePage90minState) => (state: AppState) => getHomePage(state)[key].articles;

export const getSectionDisplayNameByKey = (key: keyof HomePage90minState) => (state: AppState) => getHomePage(state)[key].displayName;

export const getSectionLinkByKey = (key: keyof HomePage90minState) => (state: AppState) => getHomePage(state)[key].link;

export const getSectionTextByKey = (key: keyof HomePage90minState) => (state: AppState) => getHomePage(state)[key].text;
